import {
  DrawerNavigationState,
  EventArg,
  TabNavigationState,
} from '@react-navigation/native';

export type SettingsStackParams = {
  Settings: undefined;
  Databases: undefined;
  Devices: undefined;
  Drive: undefined;
  Premium: undefined;
};

export type FileStackParams = {
  Files: undefined;
  Folder: FolderParams;
  Auction: AuctionParams;
  Camera: ChatParams;
};

export interface AuctionParams {
  auctionId: string;
  mnemonic: string;
  title: string;
}

export type EncoderStackParams = {
  EncoderProjects: undefined;
  Folder: FolderParams;
  EncoderProject: ProjectParams;
};

export type EditorStackParams = {
  EditorProjects: undefined;
  Folder: FolderParams;
  EditorProject: ProjectParams;
  Camera: ChatParams;
};

export type ChatStackParams = {
  Contacts: undefined;
  Folder: FolderParams;
  Chat: ChatParams;
  Camera: ChatParams;
};

export type ShopStackParams = {
  Categories: {shopId: string; mnemonic: string};
  Shops: undefined;
  Folder: FolderParams & {shopId: string; mnemonic: string};
  Product: ProductParams & {shopId: string; mnemonic: string};
  WebEditor: {shopId: string; mnemonic: string};
  ShopConfig: {shopId: string; mnemonic: string};
  Orders: {orderId?: string; shopId: string; mnemonic: string};
  Order: {orderId: string; shopId: string; mnemonic: string};
  Payouts: {payoutId?: string; shopId: string; mnemonic: string};
};

export interface ProductParams {
  parentFolderId: string;
  title: string;
  productId: string;
}

export interface ProjectParams {
  projectId: string;
  mnemonic?: string;
  parentFolderId: string;
  encoder?: string;
}

export interface FolderParams {
  folderId: string;
  mnemonic?: string;
  parentFolderId?: string;
  userId?: string;
  title: string;
}

export interface ChatParams {
  parentFolderId: string;
  name: string;
  mnemonic: string;
  chatId: string;
  page?: number;
}

export interface RootStackParams {
  Starp: {
    screen: RootStackRouteNames;
    params: {
      screen: keyof UnifiedStackParams;
      params: UnifiedStackParam;
    };
  };
}

export type ProjectsStackedParams = EditorStackParams &
  EncoderStackParams;

export type NavigationStackParams = EditorStackParams &
  EncoderStackParams &
  FileStackParams &
  ChatStackParams &
  SettingsStackParams &
  ShopStackParams;

export type UnifiedStackParams = NavigationStackParams &
  RootStackParams;

export type ExtendedNavState = EventArg<
  'state',
  undefined,
  {
    state:
      | DrawerNavigationState<NavigationStackParams>
      | TabNavigationState<NavigationStackParams>;
  }
>;

export type UnifiedStackParam =
  NavigationStackParams[keyof NavigationStackParams];

export type RootStackRouteNames =
  | 'FilesTab'
  | 'ContactsTab'
  | 'EditorTab'
  | 'EncoderTab'
  | 'SettingsTab'
  | 'ShopTab';

export const RootStackName = 'Starp';

export type StackRouteName =
  | keyof UnifiedStackParams
  | RootStackRouteNames;

export const RootScreens: {
  [key in RootStackRouteNames]: keyof UnifiedStackParams;
} = {
  ContactsTab: 'Contacts',
  EditorTab: 'EditorProjects',
  FilesTab: 'Files',
  EncoderTab: 'EncoderProjects',
  SettingsTab: 'Settings',
  ShopTab: 'Categories',
};
